require('./clean/confirm');
require('./clean/referral');
require('./clean/ui');

import {Tooltip} from "bootstrap";

/******* Tooltips *******/
let tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new Tooltip(tooltipTriggerEl)
});


if (window.showModal !== false) {
    new bootstrap.Modal(document.getElementById(window.showModal)).show();
}

/******* Menu *******/
const mobileMenu = document.getElementById('mobileMenu');
const menuBtn = document.getElementById('mobileMenuBtn');

mobileMenu.addEventListener('hide.bs.offcanvas', () => menuBtn.classList.remove("active"));
mobileMenu.addEventListener('show.bs.offcanvas', () => menuBtn.classList.add("active"));

/******* Close btn *********/
const closeBtn = document.querySelector('[data-close]');
if (closeBtn) {
    closeBtn.addEventListener('click', (event) => {
        const element = document.getElementById(event.target.dataset.close);
        if (element) {
            element.classList.add('d-none');
        }
    });
}
